import { useEffect } from "react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import InstitutionalBand from "../components/landing/InstitutionalBand";
import Opportunity from "../components/landing/Opportunity";
import HowItWorks from "../components/landing/HowItWorks";
import TrustBadges from "../components/landing/TrustBadges";
import Quote from "../components/landing/Quote";
import FinalCTA from "../components/landing/FinalCTA";
import FAQSection from "../components/landing/FAQSection";
import Footer from "../components/landing/Footer";
import MobileStickyCTA from "../components/landing/MobileStickyCTA";

export default function LandingPage() {
  useEffect(() => {
    document.title = "Prévention Conseil — Touchez jusqu'à 75 000 € de subventions FIPU CARSAT";
  }, []);

  return (
    <main className="min-h-screen pc-bg">
      <Header />
      <Hero />
      <InstitutionalBand />
      <Opportunity />
      <Quote />
      <HowItWorks />
      <TrustBadges />
      <FinalCTA />
      <FAQSection />
      <Footer />
      <MobileStickyCTA />
    </main>
  );
}
